import styled, { css } from 'styled-components';
import { mobile_xl } from '../../../global/mediaQueryMixin';

const Main = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(175px, 1fr));
  grid-template-rows: auto;
  gap: var(--space-24);
  ${mobile_xl(css`
    gap: var(--space-14);
    grid-template-columns: repeat(auto-fill, minmax(128px, 1fr));
  `)}
  .loading-animation {
    overflow: hidden;
  }
  .loading-animation::before {
    content: '';
    display: block;
    height: 100%;
    width: 100%;
    animation: loading 1s infinite;
    background: linear-gradient(to right, transparent, var(--background-tertiary), transparent);
  }

  @keyframes loading {
    0% {
      transform: translateX(-100%);
    }
    100% {
      transform: translateX(100%);
    }
  }
`;

const First = styled.div`
  border-radius: var(--border-radius-12);
  border: 0.5px solid var(--border-primary);
  background: var(--background-primary);
  box-shadow: var(--shadow-card);
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 186px;
`;
const Top = styled.div`
  padding-block: var(--space-32);
  display: flex;
  justify-content: center;
  .fill-color {
    fill: var(--background-muted);
  }
`;
const Line = styled.div`
  height: 1px;
  background-color: var(--background-muted);
`;

const Bottom = styled.div`
  display: flex;
  flex-direction: column;
  padding: var(--space-12);
  gap: var(--space-8);
`;
const FirstLine = styled.div`
  width: 70px;
  height: 12px;
  background-color: var(--background-muted);
  border-radius: var(--border-radius-8);
`;
const SecondLine = styled.div`
  background-color: var(--background-muted);
  width: 120px;
  height: 8px;
  border-radius: var(--border-radius-8);
`;
export { Main, First, Top, Bottom, Line, FirstLine, SecondLine };
